module.exports = __webpack_public_path__ + "img/flaggstikk_double_ferdig.42bcdb30.jpg";